<script type="ts">
	import { onMount } from 'svelte';
	import Time from 'svelte-time';
	import Modal from '../shared/Modal.svelte';
	import Form from './Form.svelte';
	import Loading from '../shared/Loading.svelte';
	import { storeSettings } from '../../store/StoreSettings';
	import { get } from 'svelte/store';
	import { fly } from 'svelte/transition';

	const publicKey = get(storeSettings).publicKey;
	const eventCode = get(storeSettings).eventCode;
	const invitationCode = get(storeSettings).invitationCode;
	const ticketTypeCode = get(storeSettings).ticketTypeCode;

	let modal;
	let event: any;
	let promotor: any;
	let hasAvailableTickets: boolean = false;
	let loading: boolean = true;
	let done = false;
	let error = false;

	onMount(async () => {
		modal.open();
		if (!eventCode || !publicKey || !invitationCode || !ticketTypeCode) {
			error = true;
			loading = false;
			return null;
		}
		const res = await fetch(
			`API_URL/courtesyAvailability/${eventCode}/${invitationCode}/${ticketTypeCode}`,
			{
				method: 'GET',
				headers: {
					'Content-Type': 'application/json',
					publicKey: publicKey
				}
			}
		);
		const data = await res.json();
		event = data.event;
		promotor = data.promotor;
		console.log('promotor', promotor);
		hasAvailableTickets = data.hasTickets;
		loading = false;
	});

	function formSubmited(isSubmited) {
		isSubmited ? (done = true) : (error = true);
	}
</script>

<div>
	<Modal bind:this={modal} noClose={true}>
		{#if loading}
			<div class="bg-white flex-grow overflow-auto p-20">
				<div class="flex flex-col items-center justify-center h-full">
					<Loading bind:loading />
				</div>
			</div>
		{/if}

		{#if !loading}
			<div class="flex flex-col md:flex-row">
				<!-- class="relative transform  rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full max-w-screen-lg max-h-screen overflow-auto" -->

				<div class="bg-white flex-grow overflow-auto order-2 md-order-1">
					<div class="py-16 px-8 max-w-md mx-auto" in:fly={{ y: 30 }}>
						{#if !done && !error}
							{#if hasAvailableTickets}
								<h1 class="text-lg mb-4">Ingresá tus datos para obtener una entrada de cortesía</h1>

								{#if promotor}
									<h2 class="text-sm">
										Cortesía emitida por: <span class="font-bold"
											>{promotor.name} {promotor.lastname}</span
										>
									</h2>
								{/if}
								<div class="mt-6">
									<Form on:submited={formSubmited} />
								</div>
							{/if}
							{#if !hasAvailableTickets}
								<h1 class="text-lg mb-4">No hay entradas disponibles</h1>
							{/if}
						{/if}
						{#if done}
							<h1 class="text-2xl font-semibold mb-4">¡Genial!</h1>
							<h2 class="text-xl mb-4">Tu entrada de cortesía fue solicitada!</h2>
							<p>
								En breve validaremos tu solicitud y te enviaremos un email con la entrada y el
								código QR que deberás mostrar en el acceso al evento.
							</p>
						{/if}
						{#if error}
							<h1 class="text-2xl font-semibold mb-4">Oops!</h1>
							<h2 class="text-xl mb-4">Ha ocurrido un error</h2>
							<p>
								No hemo podido procesar tu solicitud, por favor inténtalo más tarde o comunícate con
								el promotor.
							</p>
						{/if}

						<div class="flex items-center justify-center text-gray-400 text-xs p-2 mt-4 md:hidden">
							Powered by <a href="https://www.cobraticket.uy" target="_blank">
								<img
									src="https://www.cobraticket.uy/logo.svg"
									alt="Cobraticket"
									class="w-28 ml-2"
								/>
							</a>
						</div>
					</div>
				</div>
				{#if event}
					<div class="w-full md:w-1/3 bg-gray-50 flex flex-col order-1 md:order-2">
						<img class="w-full hidden md:block" src={event.image} alt={event.name} />
						<img class="w-full md:hidden" src={event.imageCover} alt={event.name} />
						<div class="flex flex-grow h-full p-4">
							<div class="flex flex-col text-center pr-5 mt-3 ">
								<div class="text-2xl line font-semibold leading-5">
									<Time timestamp={event.startAt} format="DD" />
								</div>
								<div class="text-md font-semibold uppercase leading-5">
									<Time timestamp={event.startAt} format="MMM" />
								</div>
							</div>
							<div>
								<!-- {#if event.category}
						<h4 class="text-user-primary font-semibold uppercase text-sm">
							{event.category.name}
						</h4>
					{/if} -->
								<h1 class="font-semibold text-lg inline-block transition duration-500 ease-in-out">
									{event.name}
								</h1>
								<h3 class="font-light opacity-60 text-sm flex items-center">
									<svg
										xmlns="http://www.w3.org/2000/svg"
										width="16"
										height="16"
										fill="currentColor"
										class="bi bi-clock mr-2"
										viewBox="0 0 16 16"
									>
										<path
											d="M8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71V3.5z"
										/>
										<path
											d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm7-8A7 7 0 1 1 1 8a7 7 0 0 1 14 0z"
										/>
									</svg>
									<Time timestamp={event.startAt} format="HH:mm" /> - <Time
										timestamp={event.endAt}
										format="HH:mm"
									/>
								</h3>
							</div>
						</div>
						<div class="hidden items-center justify-center text-gray-400 text-xs p-2 md:flex">
							Powered by <a href="https://www.cobraticket.uy" target="_blank">
								<img
									src="https://www.cobraticket.uy/logo.svg"
									alt="Cobraticket"
									class="w-28 ml-2"
								/>
							</a>
						</div>
					</div>
				{/if}
			</div>
		{/if}
	</Modal>
</div>
